import './CountryPage.css';

export const Cost = ({ country }) => {
    return (
        <div className="main-content">
            <section className="cost-section">
                <h2>Cost of Studying in { country.name }</h2>
                <div className="table-container">
                    <table className="cost-table">
                        <thead>
                            <tr>
                                <th>Programs</th>
                                <th>Amount in CAD (Average)</th>
                                <th>Amount in BDT (Approximately)</th>
                            </tr>
                        </thead>
                        <tbody>
                            { country.costs.map((cost) => (
                                <tr>
                                    <td>{ cost.program }</td>
                                    <td>{ cost.local }</td>
                                    <td>{ cost.bdt }</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    )
}